import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import EditIcon from 'icons/EditIcon';
import DeleteIcon from 'icons/DeleteIcon';
import { colors } from 'styles/colors';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import DeletePositionDialog from '../DeletePositionDialog/DeletePositionDialog';
import { useState } from 'react';
import { useAuth } from 'context/AuthContext';
import PositionDialog from '../PositionDialog/PositionDialog';
import DeleteReimbursementDialog from '../DeleteReimbursementDialog/DeleteReimbursementDialog';
import ReimbursementDialog from '../ReimbursementDialog/ReimbursementDialog';

interface Props {
  positionId: number;
  entity: string; // Position | Experience
}

export default function ReimbursementOptions() {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onEditClick = () => {
    handleClose();
    setOpenDialog(true);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const onDeleteClick = () => {
    handleClose();
    setOpenDelete(true);
  }

  return (
    <div>

      <IconButton
        onClick={handleClick}
        className={globalStyles.p0}
        disableRipple
      >
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <IconButton
            onClick={onEditClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <EditIcon color={colors.black} />
            </Box>
            <CustomText text="Edit" ml="5px" color={colors.black} />
          </IconButton>

          <IconButton className={globalStyles.popoverButtonContainer} onClick={onDeleteClick}>
            <Box className={globalStyles.popoverIconContainer}>
              <DeleteIcon color={colors.black} />
            </Box>
            <CustomText text="Delete" ml="5px" color={colors.black} />
          </IconButton>
        </Box>
      </Popover>

      <DeleteReimbursementDialog
        open={openDelete}
        setOpen={setOpenDelete}
      />

      <ReimbursementDialog
        open={openDialog}
        setOpen={(setOpenDialog)}
      /> 

    </div>
  );
}
